import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://njfevwmlfmdleyxukozw.supabase.co'
const SUPABASE_ANON_KEY = 'sb_publishable_brJUI40vul-mHverpd2Z8Q_ngMxUr-z'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)

// Helper: read a key from cms_data table
export async function readFromSupabase<T>(key: string): Promise<T | null> {
  try {
    const { data, error } = await supabase
      .from('cms_data')
      .select('value')
      .eq('key', key)
      .single()
    if (error || !data) return null
    return data.value as T
  } catch {
    return null
  }
}

// Helper: write a key to cms_data table (upsert)
export async function writeToSupabase<T>(
  key: string,
  value: T,
): Promise<boolean> {
  try {
    const { error } = await supabase
      .from('cms_data')
      .upsert(
        { key, value: value as any, updated_at: new Date().toISOString() },
        { onConflict: 'key' },
      )
    return !error
  } catch {
    return false
  }
}

// Helper: delete a key from cms_data table
export async function deleteFromSupabase(key: string): Promise<boolean> {
  try {
    const { error } = await supabase.from('cms_data').delete().eq('key', key)
    return !error
  } catch {
    return false
  }
}
